import Hotjar from '@hotjar/browser';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { hotjarInitialized } from './hotjar-config';

export const HotjarTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (hotjarInitialized) {
      Hotjar.stateChange(location.pathname);
    }
  }, [location.pathname]);

  return null;
};
